import {NearbyOptionItem} from '../@types';
import {AreaAnalyticsFilter, BuildingType} from '../enums';
import IconBus from './assets/icon-bus.svg';
import IconSubway from './assets/icon-subway.svg';
import IconMobileBaby from './assets/mobile-icon-baby.svg';
import IconMobileBus from './assets/mobile-icon-bus.svg';
import IconMobileHospital from './assets/mobile-icon-hospital.svg';
import IconMobileSubway from './assets/mobile-icon-subway.svg';

export const ANAYSIS_RESULT_LABELS: {[key: string]: any} = {
  [BuildingType.Apartment]: '아파트',
  [AreaAnalyticsFilter.UPCOMMING_APTS]: '입주 예정',
  [BuildingType.Villa]: '빌라',
  [BuildingType.Officetel]: '오피스텔',
  [BuildingType.HOUSE]: '단독주택',
  [AreaAnalyticsFilter.DAYCARE_CENTER]: '어린이집 원아',
  [AreaAnalyticsFilter.KINDERGARTEN]: '유치원생',
  [AreaAnalyticsFilter.ELEMENTARY_SCHOOL]: '초등학생',
  [AreaAnalyticsFilter.MIDDLE_SCHOOL]: '중학생',
  [AreaAnalyticsFilter.HIGH_SCHOOL]: '고등학생',
  [AreaAnalyticsFilter.UNIVERSITY]: '대학생',
  [AreaAnalyticsFilter.ACADEMY]: '학원',
  [AreaAnalyticsFilter.BUS]: '버스',
  [AreaAnalyticsFilter.SUBWAY]: '지하철',
  [AreaAnalyticsFilter.HOME_ELDERLY_WELFARE]: '장기요양기관',
};

export const AROUND_DATA_OPTIONS: {[key: string]: NearbyOptionItem} = {
  [AreaAnalyticsFilter.DAYCARE_CENTER]: {
    id: AreaAnalyticsFilter.DAYCARE_CENTER,
    label: '어린이집',
    order: 2,
    color: '#8E58FF',
    mobile: {
      color: '#F9AB31',
      icon: IconMobileBaby,
    },
  },
  [AreaAnalyticsFilter.KINDERGARTEN]: {
    id: AreaAnalyticsFilter.KINDERGARTEN,
    label: '유치원',
    order: 2,
    color: '#8E58FF',
    mobile: {
      color: '#FF790F',
      icon: IconMobileBaby,
    },
  },
  [AreaAnalyticsFilter.ELEMENTARY_SCHOOL]: {
    id: AreaAnalyticsFilter.ELEMENTARY_SCHOOL,
    label: '초등학교',
    order: 2,
    color: '#5200FF',
    mobile: {
      color: '#F9AB31',
    },
  },
  [AreaAnalyticsFilter.MIDDLE_SCHOOL]: {
    id: AreaAnalyticsFilter.MIDDLE_SCHOOL,
    label: '중학교',
    order: 2,
    color: '#5200FF',
    mobile: {
      color: '#FF790F',
    },
  },
  [AreaAnalyticsFilter.HIGH_SCHOOL]: {
    id: AreaAnalyticsFilter.HIGH_SCHOOL,
    label: '고등학교',
    order: 2,
    color: '#5200FF',
    mobile: {
      color: '#C86D03',
    },
  },
  [AreaAnalyticsFilter.UNIVERSITY]: {
    id: AreaAnalyticsFilter.UNIVERSITY,
    label: '대학교',
    order: 2,
    color: '#3600A8',
    mobile: {
      color: '#7BA425',
    },
  },
  [AreaAnalyticsFilter.HOSPITAL]: {
    id: AreaAnalyticsFilter.HOSPITAL,
    label: '종합병원',
    iconicStr: '병',
    order: 3,
    color: '#60B257',
    mobile: {
      color: '#FA6575',
      icon: IconMobileHospital,
    },
  },
  [AreaAnalyticsFilter.ACADEMY]: {
    id: AreaAnalyticsFilter.ACADEMY,
    label: '학원',
    order: 2,
    color: '#FF58D0',
  },
  [AreaAnalyticsFilter.HOME_ELDERLY_WELFARE]: {
    id: AreaAnalyticsFilter.HOME_ELDERLY_WELFARE,
    label: '장기요양기관',
    iconicStr: '요',
    order: 3,
    color: '#8C6120',
  },
  [AreaAnalyticsFilter.SUBWAY]: {
    id: AreaAnalyticsFilter.SUBWAY,
    label: '지하철',
    order: 4,
    color: '#00A154',
    icon: IconSubway,
    mobile: {
      color: '#0041AA',
      icon: IconMobileSubway,
    },
  },
  [AreaAnalyticsFilter.BUS]: {
    id: AreaAnalyticsFilter.BUS,
    label: '버스',
    order: 4,
    color: '#FF0000',
    icon: IconBus,
    mobile: {
      color: '#868686',
      icon: IconMobileBus,
    },
  },
};

export const MIN_SUBWAY_PASSENGERS_COUNT = 100;

export const SCHOOL_TYPES = {
  [AreaAnalyticsFilter.ELEMENTARY_SCHOOL]: 'Elementary',
  [AreaAnalyticsFilter.MIDDLE_SCHOOL]: 'Middle',
  [AreaAnalyticsFilter.HIGH_SCHOOL]: 'High',
};

export const SUBWAY_LINE_COLORS: {[key: string]: string} = {
  '1호선': '#0D347F',
  '2호선': '#33A23D',
  '3호선': '#FE5B10',
  '4호선': '#32A1C8',
  '5호선': '#8547CE',
  '6호선': '#865435',
  '7호선': '#54640D',
  '8호선': '#F51361',
  '9호선': '#AA9872',
  '공항철도 1호선': '#0065B3',
  경원선: '#0D347F',
  경부선: '#0D347F',
  경인선: '#0D347F',
  장항선: '#0D347F',
  안산선: '#32A1C8',
  과천선: '#32A1C8',
  분당선: '#F5A200',
  수인선: '#F5A200',
  경의선: '#77C4A3',
  중앙선: '#77C4A3',
  경춘선: '#0C8E72',
  경강선: '#003DA5',
  우이신설선: '#B7C452',
  공항철도: '#0065B3',
  경의중앙선: '#77C4A3',
  신분당선: '#971F2D',
  인천선: '#DBA829',
  인천2호선: '#FFB850',
  의정부경전철: '#E78522',
  용인에버라인: '#6FB26C',
  자기부상: '#E9945A',
};
